import PropTypes from 'prop-types'
import { useState, useEffect, useRef } from 'react'
import { Modal } from 'react-bootstrap'
import Slider from 'react-slick'
import sinfoto from '../../../../src/img/sinfoto.jpg'
import { sanitizeImageUrl, sanitizeYoutubeUrl } from '../../../helpers/sanitizeUrl.js'
import { toastErrorLog } from '../../../helpers/toastErrorLog'
import { toEmbedUrl } from '../../../helpers/toEmbedUrl.js'
import {
  buscarAdjuntos,
  BuscarImagenPorAdjunto
} from '../../servicios/publicacionesService'
import CarouselBig from '../carouselBig/CarouselBig'
import styles from './Carousel.module.css'
import './slick/slick.css'
import './slick/slick-theme.css'

const Carousel = ({ detalle }) => {
  const refSlider = useRef()

  const [adjuntosImg, setAdjuntosImg] = useState([])
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    detalle?.idPublicacion && obtenerImagenes()
  }, [detalle?.idPublicacion])

  useEffect(() => {
    return () => adjuntosImg.forEach((url) => URL.revokeObjectURL(url))
  }, [adjuntosImg])

  const settings = {
    dots: true,
    infinite: adjuntosImg.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px'
  }

  const obtenerImagenes = async () => {
    try {
      const { data } = await buscarAdjuntos(detalle?.idPublicacion)
      if (data.length !== 0) {
        const adjuntosOrdenados = data.sort((a, b) => a.orden - b.orden)
        await obtenerImagen(adjuntosOrdenados)
      } else {
        setAdjuntosImg((prev) => [...prev, sinfoto])
      }
      setLoading(false)
    } catch (error) {
      const mensaje = `Ocurrió un error al cargar las imagenes.`
      toastErrorLog(error, mensaje, 'adjunto')
      setLoading(false)
    }
  }

  const obtenerImagen = async (adjuntos) => {
    const imagenes = await Promise.all(
      adjuntos.map(async (a) => {
        const { data } = await BuscarImagenPorAdjunto(
          parseInt(localStorage.getItem('idUsuario')),
          detalle?.idPublicacion,
          a.idAdjunto
        )
        return data.size ? URL.createObjectURL(data) : sinfoto
      })
    )
    setAdjuntosImg(imagenes)
  }

  return (
    <>
      {loading ? (
        <div className="mx-auto spinner-border text-secondary">
          <span className="sr-only"></span>
        </div>
      ) : (
        <Slider {...settings} ref={refSlider}>
          {adjuntosImg.map((adjunto, index) => (
            <div key={index} className="slide-container">
              <img
                src={sanitizeImageUrl(adjunto, sinfoto)}
                alt={`Imagen ${index + 1}`}
                className={styles.zoomInButton}
                onClick={() => setShow(true)}
              />
            </div>
          ))}
          {detalle?.youtube && sanitizeYoutubeUrl(toEmbedUrl(detalle?.youtube)) && (
            <div className="slide-container">
              <iframe
                className={styles.youtubeContainer}
                src={sanitizeYoutubeUrl(toEmbedUrl(detalle?.youtube))}
                title="Link a YouTube"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}
        </Slider>
      )}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        id="modalCarousel"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CarouselBig idPublicacion={detalle?.idPublicacion} adjuntos={adjuntosImg} />
        </Modal.Body>
      </Modal>
    </>
  )
}

Carousel.propTypes = {
  detalle: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired,
    youtube: PropTypes.string
  }).isRequired
}
export default Carousel
